// Your web app's Firebase configuration
const firebaseConfig = {
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID
    apiKey: "AIzaSyC1fPZ4PBWqrR7sl_mlddmV4vRzcviezto",
  authDomain: "kikoo-fc728.firebaseapp.com",
  projectId: "kikoo-fc728",
  storageBucket: "kikoo-fc728.appspot.com",
  messagingSenderId: "570789777610",
  appId: "1:570789777610:web:5b97e9ce6dd23ee46d2433"
};
export default firebaseConfig;